import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import NormalTable from "Components/Common/Table";
import Modal from "Components/Common/Modal";
import ErrorMessage from "Components/ErrorMessage";
import Select from "react-select";

//utils
import { validateInput, COUNTRIES } from "Services/Utils/validateInput";

//redux
import { useDispatch } from "react-redux";
import { addCompany, checkEmail, editCompany, fetchCompanyManagementCompany, fetchCompanyManagementIndustry, fetchCompanyUsers, mapExistingUser } from "../../../../Redux/Slices/companyManagementSlice";
import { fetchCountryCode } from "../../../../Redux/Slices/countrySlice";
import { notifyError, notifySuccess } from "Services/Utils/toastNotification";
import Pagination from "Components/Pagination";
import { set } from "react-hook-form";

const EditCompany = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch country data once when the app starts
      useEffect(() => {
        dispatch(fetchCountryCode());
      }, [dispatch]);
  

  const COUNTRY_CODES = Object.entries(COUNTRIES).map(([code, name]) => ({
          value: code,
        label: `${name} (${code})`
      })).sort((a, b) => a.label.localeCompare(b.label));

  const phoneInputStyles = {
    container: {
      display: 'flex',
      // width: '33vw',
      border: '1px solid #B2BEC3',
      borderRadius: '4px',
      height: '7vh',
    },
    countryCodeSelect: {
      height: '7vh',
      width: '200px',
      border: 'none',
      borderRight: '1px solid #B2BEC3',
      borderRadius: '4px 0 0 4px',
      backgroundColor: 'white',
      color: '#697077',
      fontSize: '2.2vh',
      padding: '0 10px',
      cursor: 'pointer',
    },
    numberInput: {
      color:"black",
      width: '50%',
      border: 'none',
      borderRadius: '0 4px 4px 0',
      padding: '0 2vh',
      fontSize: '2.2vh',
      outline: 'none',
    }
  };
    
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "Name",
      sortKey: false,
    },
    {
      label: "Email Address",
      sortKey: false,
    },
    {
      label: "Country Code",
      sortKey: false,
    }
    ,
    {
      label: "Ph Number",
      sortKey: false,
    },
    {
      label: "Key Contact",
      sortKey: false,
    },
  ];

  // State to manage form inputs and users list
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");
  const [users, setUsers] = useState([]);
  const [mappedUsers, setMappedUsers] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [active, setActive] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState("")
  const [errors, setErrors] = useState({});
  const [usersOption, setUsersOptions] = useState([]);
  const [mappedUserError, setMappedUserError] = useState(false)
  const [companyUser, setCompanyUsers] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const [sortOptions, setSortOptions] = useState({ sort_by: true, order_by: "createdAt" });
  const [deletedUsers, setDeletedUsers] = useState([])
  const [editedUsers, setEditedUsers] = useState([])
  const [isKeyContactPerson, setIsKeyContactPerson] = useState(false);
  const [isKeyContactPerson_, setIsKeyContactPerson_] = useState(false);


  useEffect(()=>{
    dispatch(
      mapExistingUser({
        callBack:(value) => {
          // console.log(value)
          const updatedCategories = value.data.map(item => ({
            ...item,
            label: item.email,
            value: item.email
          }));
          setUsersOptions(updatedCategories)
        }
      })
    )
  },[])

  useEffect(()=>{
    dispatch(
      fetchCompanyUsers({
        data:{
          id,
          sort_by:sortOptions.sort_by?"ASC":"DESC",
          order_by: sortOptions.order_by, 
          page:currentPage,
          limit:10,
        },
        callBack:(value) => {
          // console.log(value)
          setCompanyUsers(value.data.rows)
          setTotalPage(value.pageMeta.totalPages || 1)
        }
      })
    )
  },[currentPage])
  
  const handleDropDownChange2 = (selectedOption) => {
    setSelectedUser(selectedOption);
    setMappedUserError(false)
  };

  const handleUserValidation = () => {
    let validationErrors = {};
  
    const nameError = validateInput("username", userName);
    if (nameError.username) {
      validationErrors.username = nameError.username;
    }
    const emailError = validateInput("email", userEmail);
    if (emailError.email) {
      validationErrors.email = emailError.email;
    }
    const codeError = validateInput("countryCode", userCountryCode);
    if (codeError.countryCode) {
      validationErrors.countryCode = codeError.countryCode;
    }  
    const numberError = validateInput("mobile", userMobile,"", userCountryCode);
    if (numberError.mobile) {
      validationErrors.mobile = numberError.mobile;
    }  
    setErrors(validationErrors);
    return validationErrors;
  }

  
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setUserMobile(value);

    setErrors(prevErrors => ({
      ...prevErrors,
      mobile: "",
    }));
  };

  const handleCountryCodeChange = (selectedOption) => {
    setUserCountryCode(selectedOption ? selectedOption.value : '');

    setErrors(prevErrors => ({
      ...prevErrors,
      countryCode: "",
    }));
  };

  // Handle adding a new user to the table
  const handleAddUser = (event) => {
    event.preventDefault();
    const validationErrors = handleUserValidation();
    if (Object.keys(validationErrors).length === 0) {

      const existingUser = users.find((user) => {
        return user.email === userEmail
      })
      if(existingUser){
        notifyError("User Already Added, Please use different Email")
      }
      else{
      dispatch(
        checkEmail({
          data:{
            mail:userEmail,
            mobile : userMobile
          },
          callBack:(value)=>{
            setUsers([
              ...users,
              {
                firstname: userName,
                email: userEmail,
                country_code: userCountryCode,
                mobile: userMobile,
                usertype: isKeyContactPerson,
                'isAdded': true,
                'isDeleted': false,
              },
            ]);
            setUserName(""); // Clear the input fields after adding
            setUserEmail("");
            setUserCountryCode("");
            setUserMobile("");
            setIsKeyContactPerson(false)
          }
        })
      )}
  }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  }; 

  // Handle deleting a user from the table
  const handleDeleteUser = (email) => {
    const updatedUsers = users.filter((user) => user.email !== email);
    setUsers(updatedUsers);
  };

  const handleDeleteMappedUser = (email) => {
    const updatedUsers = mappedUsers.filter((user) => user.email !== email);
    setMappedUsers(updatedUsers);
  };

  const handleDeleteExistingUser = (deletedUser) =>{

    console.log('inside',deletedUsers,deletedUser);
    
    setDeletedUsers([
      ...deletedUsers,
         deletedUser
    ])
  }

  const handleEditUser = (editedUser, e) => {
    console.log(e.target.checked);
  
    console.log('inside', editedUsers, editedUser);
  
    const userIndex = editedUsers.findIndex(user => user.email === editedUser.email);
  
    if (userIndex > -1) {
      const updatedUsers = [...editedUsers];
      updatedUsers.splice(userIndex, 1); // Remove the user at the found index
      setEditedUsers(updatedUsers); // Update the state with the new array
    } else {
      setEditedUsers([...editedUsers, editedUser]);
    }
  };

  const handleUndoDeleteExistingUser = (email) =>{
    console.log(deletedUsers)
    const updatedUsers = deletedUsers.filter((user) => user.email !== email);
    setDeletedUsers(updatedUsers);
  }

  const handleMapping = () => {
    if(selectedUser === ""){
      setMappedUserError(true)
    }
    else{
      const existingUser = mappedUsers.find((user) => {
        return user.email === selectedUser.email
      })
      if(existingUser){
        notifyError("User Already Mapped")
      }
      else{
      // console.log(selectedUser)
      setMappedUsers([
        ...mappedUsers,
        {
          firstname: selectedUser?.firstname,
          email: selectedUser?.email,
          country_code: selectedUser?.country_code,
          mobile: selectedUser?.mobile,
          user_id: selectedUser?.user_id,
          usertype: isKeyContactPerson_,
          "isAdded": true,
          "isDeleted": false
        },
        ]);
        setModal(false)
        setSelectedUser("");
        setIsKeyContactPerson_(false);
      }
    }
  }

  const AddCompanyFinalSubmit = () => {
    const data = {
      "company_id": id,
      "user_data": [
       ...users,
       ...mappedUsers,
       ...deletedUsers,
       ...editedUsers,
      ]
    }
    console.log(data);
    dispatch(
      editCompany({
        data,
        callBack: (value) => {
          notifySuccess("Company Edited Successfully")
          navigate(-1)
        }
      })
    )
    
  }
  return (
    <MainLayout pageName={"Company Management"}>
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Companies List</p>
      </div>
      <div className="AddUserContainer">
        {/* Header */}
        <div className="AddUserContainerHeader">
          <h2>Add Users</h2>
          <button
            className="mapUserButton"
            onClick={() => {
              setModal(true);
            }}
          >
            Map Existing User
          </button>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        <div className="AddUserInputBoxBody">
          <div className="AddUserInputContainer">
            <p>Name</p>
            <div className="AddUserInputBoxContainer">
              <InputBox
                inputStyle={{
                  boxShadow: "none",
                  border: "1px solid #B2BEC3",
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  color:"black"
                }}
                name="userName"
                value={userName}
                onChange={(e) => {setUserName(e.target.value)
                  setErrors({
                    ...errors,
                    username: "",
                  });
                }}
              />
              {errors.username && <ErrorMessage message={errors.username} />}
            </div>
          </div>
          <div className="AddUserInputContainer">
            <p>Email Address</p>
            <div className="AddUserInputBoxContainer">
              <InputBox
                inputStyle={{
                  boxShadow: "none",
                  border: "1px solid #B2BEC3",
                  padding: "1px 2vh 1px 2vh",
                  height: "7vh",
                  color:"black"
                }}
                name="userEmail"
                value={userEmail}
                onChange={(e) => {setUserEmail(e.target.value)
                  setErrors({
                    ...errors,
                    email: "",
                  })
                }
                }
              />
              {errors.email && <ErrorMessage message={errors.email} />}
            </div>
          </div>
          <div className="AddUserInputContainer">
            <p>Mobile Number</p>
            <div className="AddUserInputBoxContainer">
            <div style={phoneInputStyles.container}>
            <Select 
              options={COUNTRY_CODES}
              value={COUNTRY_CODES.find(option => option.value === userCountryCode)}
              onChange={handleCountryCodeChange}
              styles={{
                control: (provided) => ({
                  ...provided,
                  ...phoneInputStyles.countryCodeSelect,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
            <input
              style={phoneInputStyles.numberInput}
              type="tel"
              name="mobile"
              value={userMobile}
              onChange={handleMobileChange}
              placeholder="Enter phone number"
            />
          </div>
          {errors.mobile && <ErrorMessage message={errors.mobile} />}
        </div>
      </div>
          <div className="AddUserInputContainer">
              <div className="AddUserInputBoxContainer">
                <div className="display-row">
                  <div className="AddCompanyInputBoxContainer">
                    <InputBox
                      type="checkbox"
                      inputStyle={{
                        boxShadow: "none",
                        border: "1px solid #B2BEC3",
                        padding: "1px 2vh 1px 2vh",
                        height: "7vh",
                        width: 20,
                      }}
                      name="keyContactPerson"
                      value={isKeyContactPerson}
                      onChange={(e) => {
                        setIsKeyContactPerson(e.target.checked);
                      }}
                      checked={isKeyContactPerson}
                    />
                  </div>
                  <p>Key Contact Person</p>
                </div>
              </div>
            </div>
          <div className="addUserButtonContainer">
            <Button
              onClick={handleAddUser}
              buttonStyle={{ height: "2vh" }}
              title="Add"
            />
          </div>
          <hr style={{ width: "100%", marginTop: "20px" }} />
          {users.length > 0 ? (
            <div className="userTable">
              <p style={{ fontWeight: 600, fontSize: "22px" }}>Added Users</p>
              <NormalTable headerDetails={headerDetails}>
                {users.map((user, index) => (
                  <tr key={user.email} style={{ boxShadow: "0 0 1px #333" }}>
                    <td>{index + 1}</td>
                    <td>{user.firstname}</td>
                    <td>{user.email}</td>
                    <td>{user.country_code}</td>
                    <td>{user.mobile}</td>
                    <td>
                      {user.usertype ? "Yes" : "No"
                        // <InputBox
                        //   type="checkbox"
                        //   inputStyle={{
                        //     boxShadow: "none",
                        //     border: "1px solid #B2BEC3",
                        //     // padding: "1px 2vh 1px 2vh",
                        //     height: "3vh",
                        //     width: 20,
                        //   }}
                        //   name="keyContactPerson"
                        //   value={user.usertype}
                        //   onChange={(e) => {
                        //     setIsKeyContactPerson(e.target.checked);
                        //   }}
                        //   checked={user.usertype}
                        // />
                      }
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <p
                        className="deleteButton"
                        onClick={() => handleDeleteUser(user.email)}
                      >
                        Delete
                      </p>
                    </td>
                  </tr>
                ))}
              </NormalTable>
            </div>
          ) : (
            ""
          )}
          {mappedUsers.length > 0 ? (
            <div className="userTable">
              <p style={{ fontWeight: 600, fontSize: "22px" }}>Mapped Users</p>
              <NormalTable headerDetails={headerDetails}>
                {mappedUsers.map((user, index) => (
                  <tr key={user.email} style={{ boxShadow: "0 0 1px #333" }}>
                    <td>{index + 1}</td>
                    <td>{user.firstname}</td>
                    <td>{user.email}</td>
                    <td>{user.country_code}</td>
                    <td>{user.mobile}</td>
                    <td>
                      { user.usertype ? "Yes" : "No"
                        // <InputBox
                        //   type="checkbox"
                        //   inputStyle={{
                        //     boxShadow: "none",
                        //     border: "1px solid #B2BEC3",
                        //     // padding: "1px 2vh 1px 2vh",
                        //     height: "3vh",
                        //     width: 20,
                        //   }}
                        //   name="keyContactPerson"
                        //   value={user.usertype}
                        //   onChange={(e) => {
                        //     setIsKeyContactPerson(e.target.checked);
                        //   }}
                        //   checked={user.usertype}
                        // />
                      }
                    </td>                    
                    <td style={{ textAlign: "right" }}>
                      <p
                        className="deleteButton"
                        onClick={() => handleDeleteMappedUser(user.email)}
                      >
                        Delete
                      </p>
                    </td>
                  </tr>
                ))}
              </NormalTable>
            </div>
          ) : (
            ""
          )}
          {companyUser.length > 0 ? (
            <>
              <div className="userTable">
                <p style={{ fontWeight: 600, fontSize: "22px" }}>
                  Existing Users
                </p>
                <NormalTable headerDetails={headerDetails}>
                  {companyUser.map((user, index) => {
                    // Check if the user exists in the deletedUsers array
                    const isDeleted = deletedUsers.some(
                      (deletedUser) => deletedUser.email === user.email
                    );

                    return (
                      <tr
                        key={user.email}
                        style={{ boxShadow: "0 0 1px #333" }}
                      >
                        <td>{index + 1}</td>
                        <td>{user.firstname}</td>
                        <td>{user.email}</td>
                        <td>{user?.country_code || "-"}</td>
                        <td>{user.mobile}</td>
                        <td>
                          {
                            <InputBox
                              type="checkbox"
                              inputStyle={{
                                boxShadow: "none",
                                border: "1px solid #B2BEC3",
                                // padding: "1px 2vh 1px 2vh",
                                height: "3vh",
                                width: 20,
                              }}
                              name="keyContactPerson"
                              value={user.usertype}
                              onChange={(e)=>handleEditUser( 
                                {email: user.email,
                                firstname: user.firstname,
                                country_code: user?.country_code || "+91",
                                mobile: user.mobile,
                                isEdited: true,
                                // isDeleted: false,
                                usertype: e.target.checked},e)}
                                checked={editedUsers.find(editedUser => user.email === editedUser.email) ?  editedUsers.find(editedUser => user.email === editedUser.email).usertype : user.user_type === 2 ? true : false}
                              />
                          }
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <p
                            className="deleteButton"
                            onClick={
                              isDeleted
                                ? () => handleUndoDeleteExistingUser(user.email) // Call handleUndoDeleteUser if the user is deleted
                                : () =>
                                    handleDeleteExistingUser({
                                      email: user.email,
                                      firstname: user.firstname,
                                      country_code: user?.country_code || "+91",
                                      mobile: user.mobile,
                                      isAdded: false,
                                      isDeleted: true,
                                    }) // Otherwise, call handleDeleteUser
                            }
                          >
                            {isDeleted ? "Undo" : "Delete"}{" "}
                            {/* Dynamically display "Undo" or "Delete" */}
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </NormalTable>

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </>
          ) : (
            <p style={{ textAlign: "center", fontFamily: "Poppins" }}>
              No Data Found
            </p>
          )}
        </div>
        <div className="submitUserButtonsContainer">
          <div className="submitUserButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="submitUserButtonContainer">
            <Button
              buttonStyle={{ height: "2vh" }}
              title="Submit"
              onClick={AddCompanyFinalSubmit}
            />
          </div>
        </div>
      </div>
      <Modal
        open={modal}
        closeModal={() => {
          setModal(false);
        }}
      >
        <div className="mapExistingUser">
          <h4>Map Existing User</h4>
          <div className="mapExistingUserDropdownContainer">
            <p>Select User</p>
            <div className="AddCompanyInputBoxContainer">
              <DropDownBox
                options={usersOption}
                placeholder="Select"
                onChange={handleDropDownChange2}
                value={selectedUser}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #B2BEC3",
                    boxShadow: "none",
                    padding: "5px 3px",
                    fontFamily: "Poppins",
                    fontSize: "2.2vh",
                    marginRight: "10px",
                    height: "7vh",
                  }),
                }}
              />
              {mappedUserError && (
                <ErrorMessage message={"Please Map a User"} />
              )}
            </div>
          </div>
          <div className="mapExistingUserDropdownContainer">
            <div className="display-row">
              <div className="AddCompanyInputBoxContainer">
                <InputBox
                  type="checkbox"
                  inputStyle={{
                    boxShadow: "none",
                    border: "1px solid #B2BEC3",
                    padding: "1px 2vh 1px 2vh",
                    height: "7vh",
                    width: 20,
                  }}
                  name="keyContactPerson"
                  value={isKeyContactPerson_}
                  onChange={(e) => {
                    setIsKeyContactPerson_(e.target.checked);
                  }}
                  checked={isKeyContactPerson_}
                />
              </div>
              <p>Key Contact Person</p>
            </div>
          </div>
          <div className="mapExistingUserButtonsContainer">
            <div className="mapExistingUserButtonContainer">
              <Button
                buttonStyle={{
                  height: "2vh",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid black",
                }}
                titleStlye={{ color: "#888888" }}
                title="Cancel"
                onClick={() => setModal(false)}
              />
            </div>
            <div className="mapExistingUserButtonContainer">
              <Button
                buttonStyle={{ height: "2vh" }}
                title="Map"
                onClick={handleMapping}
              />
            </div>
          </div>
        </div>
      </Modal>
    </MainLayout>
  );
};

export default EditCompany;
